module.exports = __webpack_public_path__ + "static/media/hero-bcg4.115faa39.jpg";